<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card class="v-dialog--custom" v-if="visible">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          @click="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0">
        <p class="pb-2">{{ $t(`${namespace}.text`) }}</p>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          round
          depressed
          color="accent"
          @click.native="cancel"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CancelDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.cancelDialog'
    }
  },
  methods: {
    cancel () {
      this.$emit('close', true)
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
